import vienglangbac from "../assets/img/vienglangbac.png";
import chucthaygiao from "../assets/img/chucthaygiao.png";
import chucnghebao from "../assets/img/chucnghebao.png";
import chucthuy from "../assets/img/chucthuy.png";
import giumoitruong from "../assets/img/giumoitruong.png";
import khachthamque from "../assets/img/chaokhachthamque.png";
import chucnghethapruou from "../assets/img/chucnghethapruou.png";
import chucmungthapruouphule from "../assets/img/chucmungruouphule.png";
import chiecmutaibeo from "../assets/img/chiecmutaibeo.png";
import vinhlongnganxuan from "../assets/img/vinhlongnganxuan.png";
import vinhlongnganxuanSheet from "../assets/img/pages/vinhlongnganxuan.png"
import veCayDuaBenTre from "../assets/img/vecayduabentre.png"

const sangTacMoiData = [
  {
    id: 1,
    title: "Vào lăng viếng Bác",
    content: `**(Tự tin, cảm xúc)**  
(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)  
**Cái kể**: Kính thưa cô bác xóm làng…  
Chúng tôi vào lăng viếng Bác….hai hàng lụy (…ớ) rơi….  
Vào lăng thăm Bác sáng nay  
Nghe thơm trong gió hương (ơ bay (ơ) ngọt (ơ) ngào  
**Con xô**: Phải vì lòng Bác thanh (ớ) cao…  
**Cái kể**: Phải vì (ờ) lòng Bác (ớ) thanh (ớ) cao  
Nên hoa đất nước tìm vào vây (ớ) quanh  
**Con xô**: Gối non sông một giấc (ớ) lành …  
**Cái kể**: Gối non (a) sông một (ơ) giấc (ơ) lành  
Chòm râu (Bác) trắng, thoáng rung rinh (ơ) gió đèo  
**Con xô**: Nghe (ơ) từng tiếng suối trong (ớ) veo  
**Cái kể**: Nghe (ơ) từng…tiếng suối (..ớ) trong (ớ) veo  
Phập phồng Bác (ơ) thở (ơ)..nhịp (ơ) đều tim con  
**Con xô**: Lặng (ớ) im giấc Bác đang (ơ) tròn  
**Cái kể**: Lặng im (ơ..) giấc Bác (ớ) đang (ơ) tròn  
Ước gì được (ơ) Bác vẫy con (ờ…) đến gần  
**Con xô**: Một lần thôi chỉ một (ơ..) lần  
**Cái kể**: Một lần (ơ…) thôi chỉ (ơ) một lần  
Như miền Nam chỉ trong (ơ) ngần ấy thôi!  
**Con xô**: Chân con bước chậm lại rồi  
**Cái kể**: Chân con (ơ..) bước chậm (ớ..) lại (ơ) rồi  
Muốn dừng bên Bác, nghe (ơ) lời Bác khuyên  
**Con xô**: Sẽ sàng sợ động giấc hiền  
**Cái kể**: Sẽ (ơ) sàng (ơ) sợ động (ơ) giấc (ơ) hiền  
Bác vừa ngủ đó, mơ (ớ) miền Nam (…) xa  
**Con xô**: Mơ (ớ) ngày toàn thắng (ớ) về (ơ) ta  
**Cái kể**: Mơ (ơ) ngày (ờ) toàn thắng (ớ) về (ế) ta  
Bác đi thăm hỏi đường (…ớ) xa Bác (…) mừng  
**Con xô**: Bồi hồi con bước (ớ).., rưng (ớ) rưng  
**Cái kể**: Bồi hồi (….) con bước (ớ) rưng (ớ) rưng  
Thương ngày gian khổ (ố), núi (úi) rừng (ừng)- Bác (ớ) đi  
**Con xô**: Xa nơi Bác nghỉ, con về  
**Cái kể**: Xa nơi (ơ) Bác nghỉ (…ớ), con về  
Ngoái nhìn Lăng (Bác), mỗi bước đi chẳng đành  
Cái kể - Con xô: Ngoái nhìn Lăng (Bác),…. chẳng (ơ) đành… bước (ớ) đi.  

**Mốc thời gian**: Sáng tác tháng 12/1976, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: vienglangbac,
    year: "1976",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lê Hoàng Dũng sáng tác, phát triển theo điệu lý Mười hai tháng, bày tỏ lòng kính trọng và xúc động khi viếng lăng Bác.",
    modernDevelopment:
      "Được biểu diễn trong các dịp lễ hội và sự kiện tưởng niệm tại Phú Lễ.",
  },
  {
    id: 2,
    title: "Chiếc mũ tai bèo",
    content: `**(Tươi vui, phấn khởi)**  
(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)  
**Cái kể**: (nói) Anh chị em ơi!  
**Con xô**: Ơi….!!  
**Cái kể**: Yêu sao chiếc mũ (ú) tai (ơ) bèo  
Xanh xanh một mãnh (ớ) trời treo (ớ) trên (ơ) đầu  
**Con xô**: Nắng mưa sương gió dãi (ớ) dầu  
**Cái kể**: Nắng mưa (ơ) sương gió (ơ) dãi (ờ) dầu  
Vẫn xanh tươi (ớ) đẹp thêm mầu ngụy (ớ) trang  
**Con xô**: Có tai (ơ) bèo, nhớ (ớ) nón nan  
**Cái kể**: Có tai (ơ) bèo nhớ (ớ) nón (ơ) nan  
Những ngày giặc đốt, xóm làng xác (ớ) xơ  
**Con xô**: Nứa, tre ta (ơ) dệt thành (ơ) thơ  
**Cái kể**: Nứa (ớ) tre (a..) ta dệt (ơ) thành thơ  
Hai thế hệ, một ước mơ (ơ) dựng (ơ) đời  
**Con xô**: Thuở “ong vò vẽ”, “ngựa (ơ) trời”  
**Cái kể**: Thuở “ong (ơ…) vò vẽ (ơ)” “ngựa (ơ) trời”  
Đến hôm nay (có) “bê bốn mươi” (B.40) gọn (ơ) gàng  
**Con xô**: Đẹp thay chiếc mũ (ớ) lên (ơ) đàng  
**Cái kể**: Đẹp (ơ) thay (ơ…) chiếc mũ (…ớ) lên (ơ) đàng  
Đường hành quân lá – ngụy (ơ) trang gió (ớ) lùa  
**Con xô**: Vui sao đêm dưới rặng (ờ) dừa  
**Cái kể**: Vui sao (a..) đêm dưới (ơ...) rặng (ơ) dừa  
Quê hương thức giấc, những (ơ) giờ ra (ớ) quân  
**Con xô**: Gặp người trong đội dân (ớ) công  
**Cái kể**: Gặp (ơ) người (ờ…) trong (ơ) đội dân (ớ) công  
Nép trong vành mũ, mắt long lanh (ớ) cười  
**Con xô**: Nhớ nhau nhớ cả sao (ơ) trời  
**Cái kể**: Nhớ nhau (ơ) nhớ cả (ớ) sao (ơ) trời  
Mũ tay bèo vẫy theo (ơ) lời tiễn (ơ) nhau  
**Con xô**: Chúc anh lập chiến công (ơ) đầu  
**Cái kể**: Chúc anh (a) lập chiến (…ớ) công (ơ) đầu  
Anh đi dẫu mấy sông sâu (ơ) đường (ờ) dài  
**Con xô**: Tai bèo cài đóa hoa (ớ) mai  
**Cái kể**: Tai (ơ) bèo (…) cài đóa (…ớ) hoa mai  
Nhớ em, súng chắc trong (ớ) tay xuống (ớ) đường  
**Con xô**: Sáng ngời ánh mắt người (ờ) thương  
**Cái kể**: Sáng ngời (ờ…) ánh mắt (ơ…) người thương  
Tai bèo ơi (hỡi) ra chiến trường cùng (ờ) ta  
**Con xô**: Tiến công mấy đợt xông (ớ) pha  
**Cái kể**: Tiến công (ơ…) mấy đợt (ơ..) xông (ớ) pha  
Gian lao mấy trận có ta (à) có (ớ) mình  
**Con xô**: Mai đây về lại đô (ơ) thành  
**Cái kể**: Mai đây (ơ..) về lại (…ớ) đô thành  
Đường vui rợp nắng có (ó) mình, có (ó) ta  
Cái kể - Con xô: Đường vui (ơ) rộp nắng (…) có (ó) mình…., có (ó) ta.  

**Mốc thời gian**: Sáng tác tháng 12/1968, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: chiecmutaibeo,
    year: "1968",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lê Hoàng Dũng sáng tác, phát triển theo điệu lý Đầu cầu vắn, ca ngợi chiếc mũ tai bèo và tinh thần chiến đấu.",
    modernDevelopment:
      "Được trình diễn trong các dịp kỷ niệm lịch sử tại Phú Lễ.",
  },
  {
    id: 3,
    title: "Cùng nhau giữ sạch môi trường",
    content: `**(Như nói lối)**  
**Cái kể**: Kính thưa cô bác xóm làng  
Kênh mương, đường sá quê mình phải chăm nom….  
(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)  
**Cái kể**: Kênh, mương nước phải sạch (ớ) trong  
Không nên xả thải kênh mương (ờ) đen (ơ) ngòm  
**Con xô**: Chớ nên vì ích lợi riêng  
**Cái kể**: Chớ nên (ơ) vì ích (ơ) lợi (ớ) riêng  
Kênh, mương ô nhiễm dân (ớ) tình lao (ớ) dao  
**Con xô**: Dân làng chẳng biết tính sao  
**Cái kể**: Dân (ơ) làng (ờ..) chẳng biết (ớ) tính (ơ) sao  
Cá tôm chết hết, ruộng vườn héo (ơ) khô  
**Con xô**: Nếu không cho nước ra (ờ) vô  
**Cái kể**: Nếu không (ơ) cho nước (ơ) ra (ớ) vô  
Nước đâu tưới lúa, tưới (ơ) cây, tưới (ơ) dừa  
**Con xô**: Trâu bò, gà vịt, heo dê  
**Cái kể**: Trâu (ơ) bò…, gà (ơ) vịt, heo (ớ) dê  
Nước không có uống, dân quê vốn (ơ) nghèo  
**Con xô**: Sản xuất thất bát mãi theo  
**Cái kể**: Sản xuất (ơ) thất bát (ơ..) mãi (ơ) theo  
Không chỉ tại đất, (hay tại) trời gây nên  
**Con xô**: Còn vì tư lợi cá nhân  
**Cái kể**: Còn vì (ơ) tư lợi (ơ) cá nhân  
Quên làng, quên xóm, người thân, họ (ơ) hàng  
**Con xô**: Đường đi lối lại trong (ơ) làng  
**Cái kể**: Đường đi (ơ…) lối lại (…ớ) trong làng  
Rác thải bừa bãi, giữa đàng, hai (ớ) bên  
**Con xô**: Quê hương phát triển, đi (ớ) lên  
**Cái kể**: Quê hương (ơ..) phát triển (..ớ), đi lên  
Nông thôn đổi mới, phải xây tinh (ơ) thần  
**Con xô**: Dân mình ý thức nâng cao  
**Cái kể**: Dân (ơ) mình (ờ..) ý thức (ớ) nâng cao  
Quan tâm chăm sóc kênh (ớ) mương, đường (ờ) làng  
**Con xô**: Nước thải phải có hố ngăn  
**Cái kể**: Nước thải (..ờ) phải có (ơ…) hố ngăn  
Xử lý hóa chất, môi trường giảm nguy  
**Con xô**: Chớ nên bỏ rác đường đi  
**Cái kể**: Chớ nên (ơ…) bỏ rác (ớ) đường đi  
Gom vào tiêu hủy, lộ làng khang (ớ) trang  
**Con xô**: Đường đi lối lại trong làng  
**Cái kể**: Đường đi (ơ…) lối lại (ớ) trong (ơ) làng  
Kênh mương, sạch sẽ, nông thôn tuyệt (ơ) vời  
Cái kể - Con xô: Quê hương chung sức chăm (ớ) nom  
Góp phần giữ tốt môi trường quê (ớ) ta  
Cái kể - Con xô: Góp phần giữ tốt…. môi trường- quê …ta  

**Mốc thời gian**: Sáng tác tháng 1/2016, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: giumoitruong,
    year: "2016",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lư Hội sáng tác, theo điệu lý Mười hai tháng hoặc lý Đầu cầu vắn, kêu gọi bảo vệ môi trường quê hương.",
    modernDevelopment:
      "Được sử dụng trong các chương trình giáo dục môi trường tại Phú Lễ.",
  },
  {
    id: 4,
    title: "Chào mừng khách đến thăm quê",
    content: `**Cái kể**: Chào mừng quý khách………………(xa gần)  
Về quê nghe hát (…) sắc bùa….Bến (…) Tre  
(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)  
**Cái kể**: Chúc mừng quý khách …………………(gần xa)  
Một năm hạnh phúc, toàn gia an bình!  
**Con xô**: Công danh, sự nghiệp khương ninh  
**Cái kể**: Công danh (…), sự nghiệp (…) khương ninh  
Dồi dào sức khỏe, ngập tràn niềm vui!  
**Con xô**: Chung tay, chung sức xây đời  
**Cái kể**: Chung tay, chung sức xây đời  
Góp công vun đắp, nhà nhà ấm no  
**Con xô**: Vì đời, chẳng thể so đo  
**Cái kể**: Vì đời (..) chẳng thể (…) so đo  
Giúp dân, giúp nước chẳng lo, chẳng màng  
**Con xô**: Chúc (Quý) khách nhà cửa khang trang  
**Cái kể**: Chúc (Quý) khách (…) nhà cửa (…) khang trang  
Gia đình hòa thuận, nhà an bội phần  
**Con xô**: Chung lòng giúp nước, giúp dân  
**Cái kể**: Chung lòng (…) giúp nước (…), giúp dân  
Nước nhà thịnh vượng, dân quê đủ đầy  
**Con xô**: Tình nhà, ơn nước cao dầy  
**Cái kể**: Tình nhà (…), ơn nước (…) cao dầy  
Nghĩa tình, vun đắp ngày thêm cao vời  
**Con xô**: Tiền tài, danh vọng đầy vơi  
**Cái kể**: Tiền tài (…), danh vọng (…) đầy vơi  
Tình người trong sáng, bao đời ghi công  
**Con xô**: Ra về thanh thảng trong lòng  
**Cái kể**: Ra về (..) thanh thảng (…) trong lòng  
Hẹn lần sau đến, nghe chúng tôi hát bùa  
Cái kể - Con xô: Hẹn lần sau đến (….), nghe sắc bùa Bến (...) Tre!  
Cái kể - Con xô: Hẹn lần sau đến (….), nghe sắc bùa Bến (...) Tre!  

**Mốc thời gian**: Sáng tác tháng 5/2016, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: khachthamque,
    year: "2016",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Nguyễn Chấn sáng tác, chào đón khách đến thăm quê và gửi lời chúc an lành.",
    modernDevelopment:
      "Được biểu diễn trong các sự kiện văn hóa và đón khách tại Bến Tre.",
  },
  {
    id: 5,
    title: "Chúc nghề thầy giáo",
    content: `**(Nghệ nhân đờn cò dạo đầu, kết thúc phần dạo đầu, cái kể vào nhịp)**  
**Cái kể**: Ở quê tôi mở trường dạy học  
Nhiều thầy cô chẳng ngại sớm khuya  
Ngày lẫn đêm chuyên tâm, cần mẫn  
Đêm soạn giáo án, chấm bài, vào điểm  
Ngày dạy học sớm chiều động viên, thăm viếng  
Những mong sao trồng được nhiều người  
Tôi chúc cho……………… có nghề dạy học  
Bước sang năm mới nhiều trò giỏi giang, thành đạt.  
**Con xô**: Dạy học, dạy học  
**Cái kể**: Mong trò thành đạt  
**Con xô**: Lập được công danh  
**Cái kể**: Thành người hữu dụng  
**Con xô**: Giúp nước xây nhà  
**Cái kể**: Vững bền, hạnh phúc  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Sáng tác năm 2015, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: chucthaygiao,
    year: "2015",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lư Hội sáng tác, chúc mừng và tôn vinh nghề giáo viên tại Phú Lễ.",
    modernDevelopment:
      "Được trình diễn trong các dịp Ngày Nhà giáo Việt Nam tại địa phương.",
  },
  {
    id: 6,
    title: "Chúc nghề làm báo",
    content: `**(Nghệ nhân đờn cò dạo đầu, kết thúc phần dạo đầu, cái kể vào nhịp)**  
**Cái kể**: Ai muốn biết điều hay, điều tốt  
Muốn lánh xa điều xấu muộn phiền  
Hiểu đất nước phồn vinh, thịnh vượng  
Biết nhân gian phải trái, đúng sai  
Nên xem báo nghe đài thường nhật.  
Tôi chúc cho ông………….. có nghề làm báo  
Sang năm viết hay, nói tốt  
**Con xô**: Làm báo, làm báo  
**Cái kể**: Nói thiệt là hay  
**Con xô**: Nhận rõ đúng sai  
**Cái kể**: Giúp dân, giúp nước  
**Con xô**: Phát huy điều tốt  
**Cái kể**: Chống điều gian tham  
**Con xô**: Nhận rõ gian tà  
**Cái kể**: Giúp nhà, xây nước.  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Sáng tác năm 2015, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: chucnghebao,
    year: "2015",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lư Hội sáng tác, tôn vinh nghề báo và vai trò truyền tải thông tin.",
    modernDevelopment:
      "Được biểu diễn trong các sự kiện liên quan đến báo chí tại Phú Lễ.",
  },
  {
    id: 7,
    title: "Chúc nghề thú y",
    content: `**(Nghệ nhân đờn cò dạo đầu, kết thúc phần dạo đầu, cái kể vào nhịp)**  
**Cái kể**: Nhớ thuở xưa không thuốc, không thầy  
Mưa rớt hạt đầu mùa  
Heo, gà, vịt chết toi vô kể  
Nay nhờ thầy, có thuốc chích đề phòng  
Trị dứt bệnh heo, gà khỏe mạnh  
Tôi chúc cho ông……………có nghề thú y  
Năm mới thành công, viên mãn  
**Con xô**: Thú y, thú y  
**Cái kể**: Tích cực chữa trị  
**Con xô**: Tích cực phòng ngừa  
**Cái kể**: Gia cầm, gia súc  
**Con xô**: Hết bệnh, đầy đàn  
**Cái kể**: Dân tình phấn chấn  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Sáng tác năm 2015, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: chucthuy,
    year: "2015",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lư Hội sáng tác, chúc mừng nghề thú y và vai trò bảo vệ gia súc, gia cầm.",
    modernDevelopment:
      "Được trình diễn trong các sự kiện nông nghiệp tại Phú Lễ.",
  },
  {
    id: 8,
    title: "Chúc nghề kháp rượu",
    content: `**(Nghệ nhân đờn cò dạo đầu, kết thúc phần dạo đầu, cái kể vào nhịp)**  
**Cái kể**: Nhớ thuở xưa ông bà kháp rượu  
Nếp trộn men ủ kín một tuần  
Vào trả kháp, đun sôi chưng cất  
Hương rượu thơm, pha chế rượu ngon  
Tôi chúc cho (…..) có nghề kháp rượu rạng tiếng, nổi danh  
**Con xô**: Kháp rượu! kháp rượu!  
**Cái kể**: Bồ đào, mỹ tửu  
**Con xô**: Chuối hột, chuối cơm  
**Cái kể**: Rượu uống thiệt thơm  
**Con xô**: Rượu tình, rượu lễ  
**Cái kể**: Rượu biếu, rượu mua  
**Con xô**: Rượu mừng năm mới  
**Cái kể**: Rượu kính tổ tiên  
**Con xô**: Rượu đãi bạn hiền  
**Cái kể**: Xin chớ uống ghiền  
**Con xô**: Không uống liên miên  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Sáng tác năm 2016, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: chucnghethapruou,
    year: "2016",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lư Hội sáng tác, ca ngợi nghề kháp rượu truyền thống của Phú Lễ.",
    modernDevelopment:
      "Được biểu diễn trong các lễ hội rượu và sự kiện văn hóa tại Phú Lễ.",
  },
  {
    id: 9,
    title: "Chúc mừng rượu Phú Lễ",
    content: `**(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)**  
**Cái kể**: Thưa cùng quý khách xa….gần…  
Ba Tri có rượu Phú Lễ nổi danh.. thuở (..ơ…) nào….  
**Con xô**: Bảo tồn vốn quý ra sao  
**Cái kể**: Bảo tồn vốn quý ra sao  
Phát huy rượu mạnh thế nào biết chăng  
**Con xô**: Thảo dược cần đủ Ba mươi  
**Cái kể**: Thảo dược cần đủ Ba mươi  
Kỹ thuật tân tiến rượu dùng được ngay  
**Con xô**: Tạp chất loại thải thật hay  
**Cái kể**: Tạp chất loại thải thật hay  
Độ cồn lại giảm mỗi ngày nhiều hơn  
**Con xô**: Sản xuất nhiều rượu thiệt ngon  
**Cái kể**: Sản xuất nhiều rượu thiệt ngon  
Rượu ngon chuối hột, độ cồn giảm đi  
**Con xô**: Rượu mạnh thế giới thiếu chi  
**Cái kể**: Rượu mạnh thế giới thiếu chi  
Wít-ky cho đến Vót-ca so bì  
**Con xô**: Phú Lễ rượu sẽ danh ghi  
**Cái kể**: Phú Lễ rượu sẽ danh ghi  
Vươn ra thế giới dân quê tự hào  
Cái kể - Con xô: Vui xuân, đón Tết chúc nhau  
Chúc rượu Phú Lễ …., năm nào cũng tăng  
Cái kể - Con xô: Chúc rượu Phú Lễ …., năm nào cũng tăng  

**Mốc thời gian**: Sáng tác năm 2016, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: chucmungthapruouphule,
    year: "2016",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do TS. Nguyễn Nhã sáng tác, phát triển theo điệu lý Mười hai tháng, ca ngợi rượu Phú Lễ và tinh thần bảo tồn văn hóa.",
    modernDevelopment:
      "Được biểu diễn trong các lễ hội rượu và sự kiện quảng bá văn hóa Phú Lễ.",
  },
  {
    id: 10,
    title: "Vè trái dừa Bến Tre",
    content: `**(Tự tin, cảm xúc)**  
(Nghệ nhân đờn cò dạo đầu, trống phách gõ theo, kết thúc phần dạo đầu, cái kể vào nhịp)  
**Cái kể**: Bến Tre nước ngọt lắm dừa
Ruộng vườn màu mỡ biển thừa cá tôm
Sau đây tôi xin kể các loại dừa
Để bà con cùng nghe thử
Dừa sai trái dữ 
**Con xô**: là trái dừa chùm 
**Cái kể**: Dừa rụng cum cum
**Con xô**: là trái dừa mõ
**Cái kể**: Ăn vỏ giòn ngọt
**Con xô**: là trái dừa bông
**Cái kể**: Dễ cháy như không
**Con xô**: là trái dừa lửa
**Cái kể**: Khỏi chùi khỏi rửa
**Con xô**: là trái dừa khô
**Cái kể**:  Có cửa ra vô
**Con xô**: là dừa chuột khoét
**Cái kể**: Cá vô mắc kẹt 
**Con xô**: là trái dừa bung
**Cái kể**: Mắc - gai mọc cùng
**Con xô**: là trái dừa dứa
**Cái kể**: Cưới về chọn lựa
**Con xô**: là trái dừa dâu
**Cái kể**: Hiểu mà ra dấu
**Con xô**: là trái dừa câm
**Cái kể**: Trắng ải xa xăm
**Con xô**: Tam quang vàng vỏ
**Cái kể**: Nhỏ mà cốt Thái
**Con xô**: là trái dừa xiêm
**Cái kể**: Gọi mãi vẫn im
**Con xô**: là trái dừa điếc
**Cái kể**: Giống mình như thiệt
**Con xô**: là trái dừa ta
**Cái kể**: Chẳng ngựa chẳng la
**Con xô**: Mã Lai trái đỏ
**Cái kể**: Làm nến thắp tỏ
**Con xô**: là trái dừa sáp
**Cái kể**: Quấn nhừ rồi táp
**Con xô**: Là dừa trăng ăn
**Cái kể**: Mọc răng trên đầu
**Con xô**: là trái dừa mộng 
**Cái kể**: Cộng đi cộng lại
**Con xô**: Đủ các loại dừa
Cái kể - Con xô: Lời cuối xin thưa/ Lời cuối xin thưa
Quê dừa Đồng khởi


**Mốc thời gian**: Sáng tác tháng 12/1976, được ghi nhận trong cuộc khảo sát từ năm 2014.`,
    image: veCayDuaBenTre,
    year: "2017",
    type: "Sáng tác mới",
    icon: "🎶",
    description:
      "Bài hát do Lê Hoàng Dũng sáng tác, phát triển theo điệu lý Mười hai tháng, bày tỏ lòng kính trọng và xúc động khi viếng lăng Bác.",
    modernDevelopment:
      "Được biểu diễn trong các dịp lễ hội và sự kiện tưởng niệm tại Phú Lễ.",
  },
  {
    id: 11,
    title: "Vĩnh Long Ngàn Xuân",
    content: `**Cái kể**: Cửu Long miền đất chín rồng
Mêkông chín nhánh con sông xuôi dòng
**Con xô**: Xuôi dòng ra cả biển Đông
**Cái kể**: Trời Đông (a) rực ánh (á) bình minh
Mùa xuân hoa nở muôn ngàn sắc xuân
**Con xô**: Vĩnh Long ngày mới rực hồng
**Cái kể**: Vượt qua (a) ngàn dặm (a) tình nồng
Phương Nam tình đậm duyên trao lòng người
**Con xô**: Bến Tre, Trà Vinh, Vĩnh Long
**Cái kể**: Bến Tre (a) Trà Vinh (á) Vĩnh Long
Tình quê, tình đất, tình người đậm sâu
**Con xô**: Lịch sử vang dội, khắc ghi
**Cái kể**: Lịch sử (a) vang dội (a) khắc ghi
Đồng Khởi xưa ấy sử vàng lưu danh.
**Con xô**: Sử tích cùng Long Hồ Dinh
**Cái kể**: Ao Bà (Ôm) duyên thắm (á) tình trao
Vang danh di tích cổ chùa Khơme
**Con xô**: Vĩnh Long hội tụ tinh hoa
**Cái kể**: Lung linh (a) ngày mới (á) hôm nay
Cổ Chiên, Rạch Miễu, Mỹ Thuận vươn cao
**Con xô**: Công nghệ số hóa bay cao
**Cái kể**: Kề vai (a) góp sức (á) cùng nhau
Cái kể - Con xô: hát lên khúc hát lời ca khải hoàn
Cái kể - Con xô: Đón chào xuân mới… xuân son rạng ngời.

**Mốc thời gian**: Sáng tác năm 2025.`,
    image: vinhlongnganxuan,
    year: "2025",
    type: "Sáng tác mới",
    icon: "🎶",
    page: "1",
    pageRange: [1],
    pageImages: [vinhlongnganxuanSheet],
    description:
      "Bài hát được 2 bạn học sinh Bùi Thái Hiển và Bùi Phước Thông sáng tác năm 2025, ngay sau khi Bến Tre, Trà Vinh, Vĩnh Long chính thức sáp nhập thành tỉnh Vĩnh Long mới (hiệu lực 1/7/2025). Tác phẩm nhằm khẳng định tình đoàn kết, chung một lòng của nhân dân ba tỉnh, khơi dậy niềm tự hào quê hương, lịch sử và khát vọng xây dựng tỉnh mới giàu mạnh, trù phú.",
    modernDevelopment:
      "Được sử dụng trong các dịp lễ, sự kiện của tỉnh Vĩnh Long mới.",
  },
];

export default sangTacMoiData;
